import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

import type { CategoriesRes } from "./-types";

const SearchSchema = z.object({
  text: z.string().default(""),
  categoryId: z.string().optional(),
});

export const Route = createFileRoute("/_staff/apps/_list/marketplace/")({
  validateSearch: zodValidator(SearchSchema),
  /**
   * NOTE:
   * search(text/categoryId) に依存して loader を動かすと、入力中の navigate が pending/suspense を発生させ
   * input がアンマウント → フォーカス喪失が起きやすい。
   * apps 一覧は component 側で React Query によって取得し、ここではカテゴリのみを初回ロードする。
   */
  loader: async () => {
    const res = await apiClient.GET("/v2/app-categories");
    const categories = getDataOrThrowApiError(res) as CategoriesRes;
    return { categories } as const;
  },
});
